<template>
    <div>
        <trial-window/>
        <header ref="header">
            <div class="container visibility">
                <router-link :to="{name: 'Index'}" title="На главную" class="logo">
                    Astrodesign
                </router-link>
                <ul class="menu"
                    :class="{'menu-open': !!hamburgerOpened}">
                    <li>
                        <router-link :to="{name: 'Index'}" :class="{active: $route.name == 'Index'}">о проекте
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'CardCalculate'}" :class="{active: $route.name == 'CardCalculate'}">
                            рассчитать карту
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'Blog'}"
                                     :class="{active: ['Blog', 'Article'].indexOf($route.name) != -1}">
                            как пользоваться
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'Tariff'}" :class="{active: $route.name == 'Tariff'}">тарифы
                        </router-link>
                    </li>
                </ul>

                <router-link :to="{name: 'Cabinet'}" class="cabinet" v-if="userLoggedIn"><i class="fa fa-key"></i>кабинет
                </router-link>
                <router-link :to="{name: 'Login'}" class="cabinet" v-else><i class="fa fa-key"></i>войти</router-link>

                <div class="menu-icon" @click="openHamburger"><i class="fa fa-bars"></i>меню</div>
            </div>
        </header>
    </div>
</template>

<script>
    import TrialWindow from '@/components/window/TrialWindow';

    export default {
        name: 'Header',

        components: {
            TrialWindow
        },

        data() {
            return {
                hamburgerOpened: false
            }
        },

        computed: {
            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            }
        },

        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },

        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },

        methods: {
            openHamburger() {
                this.hamburgerOpened = !this.hamburgerOpened;
            },

            handleScroll() {
                this.hamburgerOpened = false;
            }
        }
    }
</script>